//8 characters, including: 1 special character, 1 number, 1 uppercase letter, and 1 lowercase letter.
export const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/
export const emailRegex = /.+@.+\..{2,}/
export const resetCodeRegex = /^\d{6}$/

export function isEmailValid(email: string) {
    return emailRegex.test(email)
}
